/**
 * Jackson on the festival server deserializes annotated Date fields
 * (`startTime` / `endTime` as UTC ISO strings). Transient `startTimeMS` /
 * `endTimeMS` are not writable on the Java models, so posting MS alone leaves
 * times null / zero on the server.
 *
 * Pattern must match:
 * yyyy-MM-dd'T'HH:mm:ss.SSS'Z' (UTC)
 */

export type ServerTimeSpan = {
  startTimeMS?: number | null;
  endTimeMS?: number | null;
  startTime?: string | null;
  endTime?: string | null;
};

export function msToServerDate(ms: number | null | undefined): string | null {
  if (ms == null || ms <= 0) {
    return null;
  }
  return new Date(ms).toISOString();
}

/** Copy a time-span object and set startTime/endTime from MS when present. */
export function withServerDateFields<T>(timeSpan: T): T {
  if (!timeSpan || typeof timeSpan !== 'object') {
    return timeSpan;
  }
  const source = timeSpan as T & ServerTimeSpan;
  const next = { ...source };
  if (next.startTimeMS != null && next.startTimeMS > 0) {
    next.startTime = msToServerDate(next.startTimeMS);
  }
  if (next.endTimeMS != null && next.endTimeMS > 0) {
    next.endTime = msToServerDate(next.endTimeMS);
  }
  return next;
}

export function withServerDateFieldsList<T>(list: T): T {
  if (!Array.isArray(list)) {
    return list;
  }
  return list.map(withServerDateFields) as T;
}
